function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" {...props}><g fill="none" fillRule="evenodd" transform="translate(1 1)"><circle cx="16" cy="16" r="16" fill="#F6F7FB" stroke="#D7DBE9" /><g fill="#6A6D7B" fillRule="nonzero"><path d="M15.222 22.222a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-1.555a5.444 5.444 0 1 0 0-10.89 5.444 5.444 0 0 0 0 10.89z" /><path d="M23.55 22.45a.778.778 0 1 1-1.1 1.1l-3.383-3.383a.778.778 0 0 1 1.1-1.1l3.383 3.383z" /></g></g></svg>;
});